import { useState, useContext } from "react";
import bgLogin from "../../Assets/Images/bgLogin.jpeg";
import adminLogo from "../../Assets/Images/darkLogo.png";
import { IoMailOutline } from "react-icons/io5";
import { LuEyeClosed } from "react-icons/lu";
import { LuEye } from "react-icons/lu";
import { validateField } from "../../libs/validationUtils";
import { login } from "../../libs/api/authApi";
import LoadingSpinner from "../../libs/LoadingSpinner";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { createChatSession } from "../../libs/api/dashboardApi";
import { AppContext } from "../../context/appContext";

export default function SignIn() {
  const { t, isRTL } = useContext(AppContext);
  const [showPassword, setShowPassword] = useState(false);
  const [formData, setFormData] = useState({ username: '', password: '' });
  const [errors, setErrors] = useState({ username: '', password: '' });
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    setErrors({ ...errors, [name]: validateField(name, value) });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const usernameError = validateField('username', formData.username);
    const passwordError = validateField('password', formData.password);
    if (usernameError || passwordError) {
      setErrors({ username: usernameError, password: passwordError });
      return;
    }
    setLoading(true);
    try {
      const payload = {
        userName: formData.username,
        password: formData.password
      }
      const response = await login(payload);
      if (response.status === 200) {
        sessionStorage.setItem("token", response.data.token);
        createChatSessionApi();
        toast.success(response.data.message);
        if (response.data.data.role && response.data.data.role.some((r) => r.name === "admin")) {
          navigate("/admin/dashboard");
        } else {
          toast.error(t('auth.notAuthorized'));
        }
      }else{
        toast.error(response.response.data.message || response.message || "Something went wrong");
      }
    } catch (error) {
      toast.error(error.response.data.message || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  const createChatSessionApi = async () => {
    const response = await createChatSession();
    if (response.status === 200 || response.status === 201) {
      sessionStorage.setItem("chatSessionId", response?.data?.session_id);
    }
  }

  return (
    <div className="min-h-screen bg-gray-100 text-gray-900 flex justify-center">
      <div className="max-w-screen-xl m-0 sm:m-10 bg-white shadow rounded-3xl flex flex-row-reverse justify-center flex-1">
        <div className="flex flex-col justify-center lg:w-1/2 xl:w-5/12 p-6 sm:p-12">
          <div>
            <img
              src={adminLogo}
              alt="Admin Logo"
              className="w-auto flex mb-3"
            />{" "}
          </div>
          <div className="mt-8  text-3xl font-bold">{t('auth.welcome')}</div>
          <form className="mt-6" onSubmit={handleSubmit}>
            <div className="flex flex-col">
              <label className="text-sm font-medium mb-2">{t('auth.username')}</label>
              <div className="relative mb-6">
                <span className={`absolute top-3.5 ${isRTL ? 'left-3' : 'right-3'}  flex items-center ${isRTL ? 'pr-4' : 'pl-4'} text-gray-500`}>
                  <IoMailOutline size={20} className='text-black' />
                </span>
                <input
                  type="text"
                  name="username"
                  value={formData.username}
                  onChange={handleChange}
                  placeholder={t('auth.enterUsername')}
                  dir="ltr"
                  className={`w-full ${isRTL ? 'pr-5 pl-12' : 'pl-5 pr-12'} py-3.5 rounded-lg bg-gray-100 text-sm focus:outline-none focus:border-indigo-500`}
                />
                {errors.username && <p className={`text-red-500 absolute mt-[3px] text-xs ${isRTL ? 'right-0' : 'left-0'}`}>{errors.username}</p>}
              </div>

              <label className="text-sm font-medium mb-2">{t('auth.password')}</label>
              <div className="relative mb-6">
                <input
                  type={showPassword ? "text" : "password"}
                  name="password"
                  value={formData.password}
                  onChange={handleChange}
                  placeholder={t('auth.enterPassword')}
                  dir="ltr"
                  className={`w-full ${isRTL ? 'pr-5 pl-12' : 'pl-5 pr-12'} py-3.5 rounded-lg bg-gray-100 text-sm focus:outline-none focus:border-indigo-500`}
                />
                <span
              className={`absolute top-3.5 ${isRTL ? 'left-3' : 'right-3'}  flex items-center ${isRTL ? 'pr-4' : 'pl-4'} text-gray-500`}
                  onClick={togglePasswordVisibility}
                >
                  {!showPassword ? <LuEyeClosed size={20} /> : <LuEye size={20} />}
                </span>
                {errors.password && <p className={`text-red-500 absolute mt-[3px] text-xs ${isRTL ? 'right-0' : 'left-0'}`}>{errors.password}</p>}
              </div>

              {/* <div className="flex justify-between items-center text-sm">
                <label className="flex items-center space-x-2">
                  <input type="checkbox" className="form-checkbox" />
                  <span>Remember me</span>
                </label>
                <a href="#" className="text-[#0D6EFD] hover:underline">
                  Forgot password?
                </a>
              </div> */}

              <button
                type="submit"
                className="w-full mt-6 bg-[#0D6EFD] text-white py-3 rounded-xl font-semibold hover:bg-indigo-600 transition"
                disabled={loading}
              >
                {loading ? <LoadingSpinner /> : t('auth.signIn')}
              </button>
            </div>
          </form>
        </div>

        <div className="rounded-l-3xl flex-1 bg-indigo-100 text-center hidden lg:flex">
          <div
            className="w-full bg-cover bg-right bg-no-repeat rounded-l-3xl"
            style={{
              backgroundImage: `url(${bgLogin})`,
            }}
          ></div>
        </div>
      </div>
    </div>
  );
}
